<template>
  <div id="app">
    <transition name="fade"><router-view></router-view></transition>  
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,700,900&display=swap');
@import url('https://fonts.googleapis.com/css?family=Roboto&display=swap');

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
a * {
	margin: 0;
	padding: 0;
}

html {
	height: 100%;
}

body {
	font-family: 'Roboto', Arial, Verdana, sans-serif;
	height: 100%;
	margin: 0px auto;
	overflow-x: hidden !important;
	background: url(assets/img/bg.jpg) no-repeat top center #f6f6f6;
	background-size:contain;
}
#app {
	height: 100%;
}
a, h1, h2, h3, h4, h5, h6, div, p, body, input, span, img {
	-webkit-transition: all 0.5s ease-in-out;
	-moz-transition: all 0.5s ease-in-out;
	-o-transition: all 0.5s ease-in-out;
	transition: all 0.5s ease-in-out;
}

::placeholder {
	/* Chrome, Firefox, Opera, Safari 10.1+ */
	color: #9c9aa0;
	opacity: 1;
	/* Firefox */
}

	{
	/* Internet Explorer 10-11 */
	color: #9c9aa0;
}

::-ms-input-placeholder {
	/* Microsoft Edge */
	color: #9c9aa0;
}
 
header {
	margin: 0px auto;
	width: 100%;
	height: 120px;
	max-width: 1140px;
}

header div:nth-Child(1) {
	float: left;
}

header div:nth-Child(1) h1 {
	background: url(assets/img/logo-big.svg) no-repeat top left;
	width: 196px;
	height: 49px;
	text-indent: -99999px;
	cursor: pointer;
	margin-top: 40px;
}

header div:nth-Child(2) {
	float: right;
}

header div:nth-Child(2) h1 {
	text-align: right;
    font-size: 20px;
    color: #ffffff;
    font-family:'Montserrat', sans-serif;
    text-transform: uppercase;
    /* font-style: italic; */
    font-weight: 300;
    margin-top: 65px;
}

@media (max-width: 1139px) {

	header {
		width: calc(100% - 60px);
		padding: 0px 30px;
	}
}

@media (max-width: 768px) {
	body {
		background: url(assets/img/bg-mobile.jpg) no-repeat top center #f6f6f6;
		background-size:contain;
	}
	header div:nth-Child(1) {
		width: 100%;
	}
	header div:nth-Child(1) h1 {
		background: url(assets/img/logo-big.svg) no-repeat top center;
		width: 100%;
		margin-top: 20px;
	}
	header div:nth-Child(2) {
		display:none;
		width: 50%;
		margin-top: 30px;
	}
	header div:nth-Child(2) h1 {
		width: 100%;
		text-align: center;
		margin-top: 0px;
	}
}

footer {
	margin: 0px auto;
	width: 100%;
	height: 120px;
	max-width: 1140px;
}

footer div:nth-Child(1) {
	float: left;
}

footer div:nth-Child(1) h1 {
	background: url(assets/img/logo-footer.svg) no-repeat top left;
	width: 159px;
	height: 49px;
	text-indent: -99999px;
	cursor: pointer;
	margin-top: 30px;
}

footer div:nth-Child(2) {
	float: right;
}

footer div:nth-Child(2) h1 {
	text-align: right;
	font-size: 14px;
	color: #acacac;
	font-weight: 400;
	margin-top: 40px;
	margin-bottom: 40px;
}

@media (max-width: 1139px) {
	footer {
		width: calc(100% - 60px);
		padding: 0px 30px;
	}
}

@media (max-width: 768px) {
	body {
		background: url(assets/img/bg-mobile.jpg) no-repeat top center #f6f6f6;
		background-size:contain;
	}
	footer div:nth-Child(1) {
		width: 100%;
	}
	footer div:nth-Child(1) h1 {
		background: url(assets/img/logo-footer.svg) no-repeat top center;
		width: 100%;
		margin-top: 20px;
	}
	footer div:nth-Child(2) {
		width: 100%;
	}
	footer div:nth-Child(2) h1 {
		width: 100%;
		text-align: center;
		margin-top: 15px;
	}
}


</style>



// WEBPACK FOOTER //
// src/App.vue